const images = {
  checkFocus: '/assets/components/CCheckbox/ic-check-focus.png',
  checkWhite: '/assets/components/CCheckbox/ic-check-white.png',
};

export default images;
